(function () {
  const carousel = document.querySelector(".series__carousel");
  const cards = document.querySelectorAll(".series__card");
  const prevBtn = document.querySelector(".series__arrow--prev");
  const nextBtn = document.querySelector(".series__arrow--next");

  if (!carousel || cards.length === 0) return;

  let currentIndex = 0;
  let startX = 0;
  let isDragging = false;

  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function updateCarousel(animate) {
    if (!isMobile()) {
      carousel.style.transform = "translateX(0)";
      return;
    }

    if (animate === false) {
      carousel.style.transition = "none";
    } else {
      carousel.style.transition = "transform 0.5s ease-in-out";
    }

    carousel.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  function goTo(index) {
    const total = cards.length;
    currentIndex = ((index % total) + total) % total;
    updateCarousel();
  }

  prevBtn?.addEventListener("click", () => goTo(currentIndex - 1));
  nextBtn?.addEventListener("click", () => goTo(currentIndex + 1));

  carousel.addEventListener("touchstart", (e) => {
    if (!isMobile()) return;
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  carousel.addEventListener("touchmove", (e) => {
    if (!isDragging || !isMobile()) return;
    const deltaX = e.touches[0].clientX - startX;
    const offset = -currentIndex * 100 + (deltaX / window.innerWidth) * 100;
    carousel.style.transition = "none";
    carousel.style.transform = `translateX(${offset}%)`;
  }, { passive: true });

  carousel.addEventListener("touchend", (e) => {
    if (!isDragging || !isMobile()) return;
    isDragging = false;
    const deltaX = e.changedTouches[0].clientX - startX;

    if (deltaX > 50) {
      goTo(currentIndex - 1);
    } else if (deltaX < -50) {
      goTo(currentIndex + 1);
    } else {
      updateCarousel();
    }
  }, { passive: true });

  window.addEventListener("resize", () => updateCarousel(false));
  updateCarousel(false);
})();
